import React from 'react';
import { 
  Target, TrendingUp, Cpu, CheckCircle, 
  Users, Zap as Lightning 
} from 'lucide-react';

const StartupBenefits = () => {
  return (
    <section className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-slate-900 mb-4">
            Une Équipe Adaptée aux Startups
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Nous comprenons les défis uniques des startups et nous adaptons à votre rythme de croissance
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="p-8 rounded-2xl bg-white shadow-sm hover:shadow-md transition-shadow duration-300">
            <Target className="w-10 h-10 text-orcsys-500 mb-6" />
            <h3 className="text-xl font-semibold text-slate-900 mb-3">Prototypage Rapide</h3>
            <p className="text-slate-600">
              Validation rapide de vos idées avec des prototypes fonctionnels. Itérations courtes pour tester le marché efficacement.
            </p>
            <ul className="mt-4 space-y-2">
              <li className="flex items-center text-sm text-slate-600">
                <CheckCircle className="w-4 h-4 text-orcsys-500 mr-2" />
                MVP en quelques semaines
              </li>
              <li className="flex items-center text-sm text-slate-600">
                <CheckCircle className="w-4 h-4 text-orcsys-500 mr-2" />
                Tests utilisateurs rapides
              </li>
            </ul>
          </div>
          
          <div className="p-8 rounded-2xl bg-white shadow-sm hover:shadow-md transition-shadow duration-300">
            <TrendingUp className="w-10 h-10 text-orcsys-500 mb-6" />
            <h3 className="text-xl font-semibold text-slate-900 mb-3">Adaptabilité Maximale</h3>
            <p className="text-slate-600">
              Une équipe qui s'adapte à vos changements de direction et aux retours du marché en temps réel.
            </p>
            <ul className="mt-4 space-y-2">
              <li className="flex items-center text-sm text-slate-600">
                <CheckCircle className="w-4 h-4 text-orcsys-500 mr-2" />
                Pivots rapides possibles
              </li>
              <li className="flex items-center text-sm text-slate-600">
                <CheckCircle className="w-4 h-4 text-orcsys-500 mr-2" />
                Équipe flexible et réactive
              </li>
            </ul>
          </div>

          <div className="p-8 rounded-2xl bg-white shadow-sm hover:shadow-md transition-shadow duration-300">
            <Cpu className="w-10 h-10 text-orcsys-500 mb-6" />
            <h3 className="text-xl font-semibold text-slate-900 mb-3">Architecture Évolutive</h3>
            <p className="text-slate-600">
              Solutions conçues pour évoluer avec votre croissance, de quelques utilisateurs à des millions.
            </p>
            <ul className="mt-4 space-y-2">
              <li className="flex items-center text-sm text-slate-600">
                <CheckCircle className="w-4 h-4 text-orcsys-500 mr-2" />
                Infrastructure cloud scalable
              </li>
              <li className="flex items-center text-sm text-slate-600">
                <CheckCircle className="w-4 h-4 text-orcsys-500 mr-2" />
                Optimisation des coûts
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-8">
          <div className="p-8 rounded-2xl bg-orcsys-50/50 border border-orcsys-100">
            <h3 className="text-xl font-semibold text-slate-900 mb-4 flex items-center">
              <Lightning className="w-6 h-6 text-orcsys-500 mr-2" />
              Méthodologie Lean
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <CheckCircle className="w-5 h-5 text-orcsys-500 mr-3 mt-0.5" />
                <span className="text-slate-600">Sprints courts de 1-2 semaines</span>
              </li>
              <li className="flex items-start">
                <CheckCircle className="w-5 h-5 text-orcsys-500 mr-3 mt-0.5" />
                <span className="text-slate-600">Déploiements continus</span>
              </li>
              <li className="flex items-start">
                <CheckCircle className="w-5 h-5 text-orcsys-500 mr-3 mt-0.5" />
                <span className="text-slate-600">Feedback quotidien</span>
              </li>
            </ul>
          </div>

          <div className="p-8 rounded-2xl bg-orcsys-50/50 border border-orcsys-100">
            <h3 className="text-xl font-semibold text-slate-900 mb-4 flex items-center">
              <Users className="w-6 h-6 text-orcsys-500 mr-2" />
              Équipe Dédiée
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <CheckCircle className="w-5 h-5 text-orcsys-500 mr-3 mt-0.5" />
                <span className="text-slate-600">Communication directe avec les développeurs</span>
              </li>
              <li className="flex items-start">
                <CheckCircle className="w-5 h-5 text-orcsys-500 mr-3 mt-0.5" />
                <span className="text-slate-600">Expertise technique et business</span>
              </li>
              <li className="flex items-start">
                <CheckCircle className="w-5 h-5 text-orcsys-500 mr-3 mt-0.5" />
                <span className="text-slate-600">Disponibilité et réactivité</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StartupBenefits; 